import React from 'react';
var md5 = require('js-md5');


const getThumbnail = (image) =>{
    var image = image;
    if(image.startsWith("https://dealmachine.s3.amazonaws.com")){
      var thumbnail = image.replace("dealmachine", "dealmachineresized");
      thumbnail = thumbnail.replace("deals", "resized-deals");
      return thumbnail;
    }else{
      return image;
    }

}

const ProfilePic = ({ email, image, size, mask }) => {


  var url = "";
  if(image && image != ""){
    url = getThumbnail(image);
  }else{
    var hash = md5(email);
    url = "https://www.gravatar.com/avatar/"+hash+"?s=100.jpg&d=mm";
  }

  return (

    <div className="dm-profile-image">
      <img src={url}
        style={{
          width:size || 60,
          height:size || 60,
          borderRadius:size ? size/2 : 30
        }}

      />
    </div>
  );
}

export { ProfilePic };



// WEBPACK FOOTER //
// ./src/components/common/ProfilePic.js